import { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { setConfigurationLoginModalOpen } from '../../../store/actions'
//import { updateSearchParameters } from '../../../store/actions/search'
import { logEvent } from '../../../utilities'
import { trimFileLink } from '../../cdl-react-components/utilities/files'
import { WEBHOST_URL } from '../../cdl-react-components/utilities/constants'
//import { SearchParameter } from '../../../utilities/models'
import { CONTENT_MODE } from '../../../utilities/constants'

import ActivityMapDesktop from './ActivityMapDesktop'
import ActivityMapMobile from './ActivityMapMobile'
import { graphqlFetch } from '../../cdl-react-components/utilities'

const ActivityMap = () => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const user = useSelector(_ => _.data.user)
    const authenticated = useSelector(_ => _.data.authenticated)
    const contentMode = useSelector(_ => _.data.configuration.contentMode)
    const [activityMap, setActivityMap] = useState()

    useEffect(() => {
        fetchActivityMap(id)
    }, [id])

    const login = () => dispatch(setConfigurationLoginModalOpen(true))

    const buildPdfLocation = () => WEBHOST_URL + '/' + trimFileLink(activityMap.pdf)
    const buildSamplePdfLocation = () => WEBHOST_URL + '/' + trimFileLink(activityMap.sample_pdf)

    // TODO <= I don't know what this is for, but apparently i had plans for it; so it's staying here - rrogers.
    // const handleSearchArticles = () => 
    //     dispatch(updateSearchParameters([
    //         new SearchParameter('keyword', encodeURIComponent(activityMap.title)),
    //         new SearchParameter('contentTypes', ['articles'])]))

    const fetchActivityMap = useCallback((activityMapId) => {
        /* Updating the state in this function will cause another update to occur.
           As such this function will be called again causing an infinite loop.
           Only update the state if it needs to be updated. - rrogers 2018-07-05 */
        if (activityMapId &&
            (!activityMap || activityMap.id !== parseInt(activityMapId))
        ) {
            logEvent({ Activity_Map_Viewed: activityMapId })
            graphqlFetch('wcms3', `
                query {
                    activityMaps (
                        where: { id: { eq: ${activityMapId} } }
                    ) {
                        items {
                            id
                            title
                            subtitle
                            publication_date: publicationDate
                            published
                            add_image: addImage
                            coming_soon: comingSoon                            
                            cover_image: coverImage
                            description
                            image_alt_text: imageAltText
                            nid
                            pdf
                            pdf_size_field: pdfFileSize
                            quarter_volumn: quarterVolumn {
                                name
                            }
                            sample_pdf: samplePdf
                            search_field: searchField
                            year
                            zone_of_interest: zoneOfInterest {
                                id
                                name
                            }
                        }
                    }
                }`)
                .then(res => {
                    if (res.data.activityMaps.length === 0) 
                        return navigate('/')
                    else {
                        const activityMap = res.data.activityMaps.items[0]
                        activityMap.quarter_volumn = activityMap.quarter_volumn?.name
                        activityMap.zone_of_interest = activityMap.zone_of_interest?.id
                                                
                        setActivityMap(activityMap)
                    }                    
                })

        }
    }, [activityMap, navigate])

    const logMapOpened = () => new Promise(res => {
        logEvent({ 'Activity_Map_Opened': activityMap.id })
        res()
    })

    return activityMap ? (
        contentMode === CONTENT_MODE.MOBILE ?
            (<ActivityMapMobile
                activityMap={activityMap} 
                handleLogin={login} 
                authenticated={authenticated}
                user={user}
                link={buildPdfLocation()}
                sampleLink={buildSamplePdfLocation()}
                logMapOpened={logMapOpened} />) :
            (<ActivityMapDesktop 
                activityMap={activityMap} 
                handleLogin={login} 
                authenticated={authenticated}
                user={user}
                link={buildPdfLocation()}
                sampleLink={buildSamplePdfLocation()} 
                logMapOpened={logMapOpened} /> )
    ): null
}

export default ActivityMap
